import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import tableDataReducer from "./reducers/tableDataSlice";
import filterReducer from "./reducers/filterSlice";
import csvDataReducer from "./reducers/csvDataSlice";
import saveStopEventsReducer from "./reducers/saveStopEventsSlice";
import tmsMetaDataReducer from "./reducers/tmsMetaDataSlice";
import userInfoReducer from "./reducers/userInfoSlice";
import retriggerEventReducer from "./reducers/retriggerEventSlice";
import commentsReducer from "./reducers/commentsSlice";
import addCommentReducer from "./reducers/addCommentSlice";
import locationMetadataReducer from "./reducers/locationMetadataSlice";
import carrierServiceMetadataReducer from "./reducers/carrierServiceMetadataSlice";
import summaryReducer from "./reducers/summarySlice";
import carrierInfoReducer from "./reducers/carrierInfoSlice";
import setOpenMenuReducer from "./reducers/leftMenuSlice";
import getDrmTableDataReducer from "./reducers/drmTableDataSlice";
// import drmMasterDataReducer from "./reducers/drmMasterDataSlice";
import drmLiveLoadMasterDataReducer from "./reducers/drmLiveLoadMasterDataSlice";
import drmTableFilterReducer from "./reducers/drmTableFilterSlice";
import drmDailyTableFilterReducer from "./reducers/drmDailyTableFilterSlice";
import drmCustomColumnReducer from "./reducers/drmCustomColumnSlice";
import excelDataReducer from "./reducers/excelDataSlice";
import coupaFileUploadReducer from "./reducers/coupaFileUploadSlice";
import drmCoupaTableFilterReducer from "./reducers/drmCoupaTableFilterSlice";

import rootSaga from "./sagas/rootSaga";
import drmUpdateTableDataReducer from "./reducers/drmUpdateTableDataSlice";
import drmtDeleteTableDataReducer from "./reducers/drmtDeleteTableDataSlice";
import drmtSubmitTableDataReducer from "./reducers/drmtSubmitTableDataSlice";
import selectedMenuReducer from "./reducers/drmtSelectMenu";
import drmChangeLogTableDataReducer from "./reducers/drmChangeLogTableDataSlice";
import drmCEAZipDownloadReducer from "./reducers/drmCEAZipDownloadSlice";
import drmDailyRecordCancelReducer from "./reducers/drmDailyRecordCancelSlice";
import drmReportDetailsReducer from "./reducers/drmReportDetailsSlice";
import drmCoupaFileDeleteDetailsReducer from "./reducers/drmCoupaFIleDeleteDetailsSlice";
import drmCoupaDeleteReducer from "./reducers/drmCoupaDeleteSlice";
import drmCoupaUpdateReducer from "./reducers/drmCoupaUpdateSlice";
import drmCeaProfileFilterReducer from "./reducers/drmCeaProfileTableFilterSlice";
import drmCeaProfileListReducer from "./reducers/drmCeaProfileListSlice";
import drmCeaProfileDownloadReducer from "./reducers/drmCeaProfileDownloadSlice";
import drmInactiveCeaReducer from "./reducers/drmInactiveCeaSlice";
import drmExpireTableDataReducer from "./reducers/drmExpireTableDataSlice";
import drmCoupaExpireReducer from "./reducers/drmCoupaExpireSlice";


const saga = createSagaMiddleware();

const store = configureStore({
  reducer: {
    loadDetails: tableDataReducer,
    filterSelected: filterReducer,
    csvDetails: csvDataReducer,
    tmsMetaData: tmsMetaDataReducer,
    edit: saveStopEventsReducer,
    user: userInfoReducer,
    retrigger: retriggerEventReducer,
    userComments: commentsReducer,
    addNewComment: addCommentReducer,
    locationMetadata: locationMetadataReducer,
    carrierMetadata: carrierServiceMetadataReducer,
    chartSummary: summaryReducer,
    carrier: carrierInfoReducer,

    leftMenu: setOpenMenuReducer,
    drmTableData: getDrmTableDataReducer,
    selectedMenu: selectedMenuReducer,
    masterData: drmLiveLoadMasterDataReducer,
    drmFilterPayload: drmTableFilterReducer,
    drmDailyFilterPayload: drmDailyTableFilterReducer,
    customColumn: drmCustomColumnReducer,
    excelTableData: excelDataReducer,
    drmCoupaFile: coupaFileUploadReducer,
    drmCoupaFilterPayload: drmCoupaTableFilterReducer,
    drmUpdates: drmUpdateTableDataReducer,
    drmSubmit: drmtSubmitTableDataReducer,
    drmDelete: drmtDeleteTableDataReducer,
    drmChangeLog: drmChangeLogTableDataReducer,
    ceaZipReportData: drmCEAZipDownloadReducer,
    drmDailyRecordCancel: drmDailyRecordCancelReducer,
    drmReportDetails: drmReportDetailsReducer,
    drmCoupaFileDeleteDetails: drmCoupaFileDeleteDetailsReducer,
    drmCoupaDelete: drmCoupaDeleteReducer,
    drmCoupaUpdate: drmCoupaUpdateReducer,
    drmCeaProfileFilterPayload: drmCeaProfileFilterReducer,
    drmCeaProfileList: drmCeaProfileListReducer,
    drmCeaProfileDownload: drmCeaProfileDownloadReducer,
    drmInactiveCea: drmInactiveCeaReducer,
    drmExpire: drmExpireTableDataReducer,
    drmCoupaExpire: drmCoupaExpireReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ thunk: false }).concat(saga),
});

saga.run(rootSaga);

export default store;
